import { DemensionAndWeightAppearanceTypeEnum } from "commons/enum/appearance-type";
import { InspectionOtherStandard } from "commons/enum/inspection";
import { OptionItem } from "commons/ultilities/dynamic-form/models/control";

export const getOthersStandardOptions = (): OptionItem[] => {
  return [
    {
      value: InspectionOtherStandard.None,
      label: "-",
    },
    {
      value: InspectionOtherStandard.HotStamping,
      label: "Ép Nhũ (Hot Stamping)",
    },
    {
      value: InspectionOtherStandard.Embossing,
      label: "Bế Nổi (Embossing)",
    },
    {
      value: InspectionOtherStandard.BrailleStamping,
      label: "Khiếm Thị (Braille Stamping)",
    },
    {
      value: InspectionOtherStandard.Special,
      label: "Hiệu Ứng Khác (Special Effects)",
    },
    {
      value: InspectionOtherStandard.HotStampingAndBrailleStamping,
      label: "Ép Nhũ, Khiếm Thị (Hot Stamping, Braille Stamping)",
    },
    {
      value: InspectionOtherStandard.HotStampingAndEmbossing,
      label: "Ép Nhũ, Bế Nổi (Hot Stamping, Embossing)",
    },
    {
      value: InspectionOtherStandard.HotStampingAndSpecial,
      label: "Ép Nhũ, Hiệu Ứng Khác (Hot Stamping, Special Effects)",
    },
    {
      value: InspectionOtherStandard.BrailleStampingAndSpecial,
      label: "Khiếm Thị, Hiệu Ứng Khác (Braille Stamping, Special Effects)",
    },
  ];
};

export const getLabelOfOthersStandard = (standard: InspectionOtherStandard) => {
  const otherStandardOpts = getOthersStandardOptions();
  const item = otherStandardOpts.filter((x) => x.value === standard)?.[0];
  return item?.label || "";
};

export const getAppearanceTypeOptions = (): OptionItem[] => {
  return [
    {
      value: DemensionAndWeightAppearanceTypeEnum.None,
      label: "-",
    },
    {
      value: DemensionAndWeightAppearanceTypeEnum.Box,
      label: "Hộp",
    },
    {
      value: DemensionAndWeightAppearanceTypeEnum.Leaflet,
      label: "Toa",
    },
    {
      value: DemensionAndWeightAppearanceTypeEnum.Label,
      label: "Nhãn",
    },
    {
      value: DemensionAndWeightAppearanceTypeEnum.Blister,
      label: "Vỉ",
    },
    {
      value: DemensionAndWeightAppearanceTypeEnum.PaperBoard,
      label: "Bìa",
    },
    {
      value: DemensionAndWeightAppearanceTypeEnum.CardBoard,
      label: "Ngăn",
    },
  ];
};

export const getLabelOfAppearanceType = (
  standard: DemensionAndWeightAppearanceTypeEnum
) => {
  const otherStandardOpts = getAppearanceTypeOptions();
  const item = otherStandardOpts.filter((x) => x.value === standard)?.[0];
  return item?.label || "";
};

export const getAppearanceDescType = (
  standard: DemensionAndWeightAppearanceTypeEnum
) => {
  switch (standard) {
    case DemensionAndWeightAppearanceTypeEnum.None:
      return "";
    case DemensionAndWeightAppearanceTypeEnum.Box:
      return "In rõ ràng, độ bóng tốt, không trầy xước, dao bế và gấp dán chính xác, hộp không biến dạng (Clear printing, good coating, no scratches, precise die-cutting and folding, box is not deformed)";
    case DemensionAndWeightAppearanceTypeEnum.Leaflet:
      return "In rõ ràng, không trầy xước, đường cắt sắc nét chính xác, toa không bị nhăn và không biến dạng (Clear printing, no scratches, sharp and precise cutting line, leaflet is not wrinkled or deformed)";
    case DemensionAndWeightAppearanceTypeEnum.Label:
      return "In rõ ràng, độ bóng tốt, không trầy xước, dao bế chính xác, nhãn không bị nhăn và không biến dạng (Clear printing, good coating, no scratches, precise die-cutting, label is not wrinkled or deformed)";
    case DemensionAndWeightAppearanceTypeEnum.Blister:
      return "Độ bóng tốt, không trầy xước, dao bế và gấp dán chính xác, vỉ không bị nhăn và không biến dạng (Good coating, no scratches, precise die-cutting and folding, blister tray is not wrinkled or deformed)";
    case DemensionAndWeightAppearanceTypeEnum.PaperBoard:
      return "In rõ ràng, độ bóng tốt, không trầy xước, dao bế và gấp dán chính xác, bìa không biến dạng (Clear printing, good coating, no scratches, precise die-cutting and folding, paperboard is not deformed)";
    case DemensionAndWeightAppearanceTypeEnum.CardBoard:
      return "In rõ ràng, độ bóng tốt, không trầy xước, dao bế và gấp dán chính xác, Ngăn không biến dạng (Clear printing, good coating, no scratches, precise die-cutting and folding, cardboard is not deformed)";
    default:
      return "";
  }
};
